export default "__VITE_ASSET__D937rfL5__"